import React, { useState } from 'react';
import { Upload, Loader2 } from 'lucide-react';

const FileImport = ({ onImportSuccess, apiEndpoint }) => {
  const [importing, setImporting] = useState(false);
  const [importError, setImportError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleFileImport = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['.csv', '.ods'];
    const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    if (!validTypes.includes(fileExtension)) {
      setImportError("Please upload only CSV or ODS files");
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    setImporting(true);
    setImportError("");
    setSuccessMessage("");

    try {
      // Make sure to use the correct import endpoint
      const importUrl = `${apiEndpoint}/import`;
      console.log('Sending import request to:', importUrl);
      
      const response = await fetch(importUrl, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Import failed');
      }

      const result = await response.json();
      setSuccessMessage(result.message || "File imported successfully!");
      
      // Clear the file input
      event.target.value = '';
      
      if (onImportSuccess) {
        onImportSuccess();
      }
    } catch (error) {
      console.error('Import error:', error);
      setImportError(error.message || "Error importing file");
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="space-y-4">
      <label className="relative cursor-pointer bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center disabled:opacity-50 disabled:cursor-not-allowed">
        {importing ? (
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
        ) : (
          <Upload className="mr-2 h-4 w-4" />
        )}
        {importing ? "Importing..." : "Import CSV/ODS"}
        <input
          type="file"
          className="hidden"
          accept=".csv,.ods"
          onChange={handleFileImport}
          disabled={importing}
        />
      </label>

      {importError && (
        <div className="bg-red-50 text-red-800 px-4 py-3 rounded-lg mt-2 border border-red-200">
          {importError}
        </div>
      )}

      {successMessage && (
        <div className="bg-green-50 text-green-800 px-4 py-3 rounded-lg mt-2 border border-green-200">
          {successMessage}
        </div>
      )}
    </div>
  );
};

export default FileImport;